<script>
import { mapState, mapActions } from 'vuex'

export default {
   data() {
      return {
         loading: false,
         fields: [
            {
               key: 'no', label: 'No', sortable: false, thClass: 'text-center align-middle',
            },
            { key: 'instansi', label: 'Nama Instansi', sortable: false },
            {
               key: 'tw1', label: 'Triwulan I', sortable: false, thClass: 'text-center align-middle',
            },
            {
               key: 'tw2', label: 'Triwulan II', sortable: false, thClass: 'text-center align-middle',
            },
            {
               key: 'tw3', label: 'Triwulan III', sortable: false, thClass: 'text-center align-middle',
            },
            {
               key: 'tw4', label: 'Triwulan IV', sortable: false, thClass: 'text-center align-middle',
            },
         ],
      }
   },
   computed: {
      ...mapState({
         instansiTriwulan: state => state.DashboardSkm.instansiTriwulan,
         tahun: state => state.DashboardSkm.tahun,
         refreshTimestamp: state => state.DashboardSkm.refreshTimestamp,
         skin: state => state.appConfig.layout.skin,
      }),
      isDark() {
         return this.skin === 'dark'
      },
      tableItems() {
         return (this.instansiTriwulan.data || []).map((item, index) => {
            const skm = item.skm || {}

            return {
               no: index + 1,
               instansi: item.instansi,
               tw1: skm.tw1 || {},
               tw2: skm.tw2 || {},
               tw3: skm.tw3 || {},
               tw4: skm.tw4 || {},
            }
         })
      },
   },
   watch: {
      tahun(newYear, oldYear) {
         if (newYear !== oldYear) this.loadData(newYear)
      },
      refreshTimestamp() {
         this.loadData(this.tahun)
      },
   },
   mounted() {
      this.loadData(this.tahun)
   },
   methods: {
      ...mapActions({
         getInstansiTriwulan: 'DashboardSkm/getInstansiTriwulan',
      }),
      async loadData(year) {
         this.loading = true
         try {
            await this.getInstansiTriwulan(year)
         } catch (error) {
            // Tabel tetap menampilkan data kosong saat request gagal.
         } finally {
            this.loading = false
         }
      },
      gradeVariant(grade) {
         switch (grade) {
         case 'A':
            return 'success'
         case 'B':
            return 'primary'
         case 'C':
            return 'warning'
         case 'D':
            return 'danger'
         case 'E':
            return 'danger'
         default:
            return 'secondary'
         }
      },
   },
}
</script>

<template>
   <b-overlay
      :show="loading"
      :variant="isDark ? 'dark' : 'white'"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
   >
      <b-row>
         <b-col cols="12">
            <b-card
               class="card-wrapper"
               :class="{ 'card-wrapper-dark': isDark }"
            >
               <div class="d-flex justify-content-between align-items-center mb-1">
                  <div>
                     <h4 class="mb-25">
                        IKM per Instansi
                     </h4>
                     <small class="text-muted">Rekap indeks SKM setiap instansi Tahun {{ tahun }}</small>
                  </div>
               </div>

               <b-table
                  :items="tableItems"
                  :fields="fields"
                  responsive
                  bordered
                  striped
                  hover
                  show-empty
                  empty-text="Belum ada data"
                  class="skm-table"
               >
                  <template #cell(no)="data">
                     <span class="font-weight-bolder">{{ data.item.no }}</span>
                  </template>

                  <template #cell(instansi)="data">
                     <span class="text-wrap font-weight-bold">{{ data.item.instansi }}</span>
                  </template>

                  <template #cell(tw1)="data">
                     <span class="font-weight-bolder">{{ data.item.tw1.indeks }}</span>
                     <b-badge
                        v-if="data.item.tw1.grade && data.item.tw1.grade !== '-'"
                        :variant="gradeVariant(data.item.tw1.grade)"
                        class="ml-50"
                     >
                        {{ data.item.tw1.grade }}
                     </b-badge>
                  </template>

                  <template #cell(tw2)="data">
                     <span class="font-weight-bolder">{{ data.item.tw2.indeks }}</span>
                     <b-badge
                        v-if="data.item.tw2.grade && data.item.tw2.grade !== '-'"
                        :variant="gradeVariant(data.item.tw2.grade)"
                        class="ml-50"
                     >
                        {{ data.item.tw2.grade }}
                     </b-badge>
                  </template>

                  <template #cell(tw3)="data">
                     <span class="font-weight-bolder">{{ data.item.tw3.indeks }}</span>
                     <b-badge
                        v-if="data.item.tw3.grade && data.item.tw3.grade !== '-'"
                        :variant="gradeVariant(data.item.tw3.grade)"
                        class="ml-50"
                     >
                        {{ data.item.tw3.grade }}
                     </b-badge>
                  </template>

                  <template #cell(tw4)="data">
                     <span class="font-weight-bolder">{{ data.item.tw4.indeks }}</span>
                     <b-badge
                        v-if="data.item.tw4.grade && data.item.tw4.grade !== '-'"
                        :variant="gradeVariant(data.item.tw4.grade)"
                        class="ml-50"
                     >
                        {{ data.item.tw4.grade }}
                     </b-badge>
                  </template>
               </b-table>
            </b-card>
         </b-col>
      </b-row>
   </b-overlay>
</template>

<style scoped>
.card-wrapper {
   border: 0;
   border-radius: 12px;
   box-shadow: 0 4px 24px rgba(34, 41, 47, 0.08);
   background-color: #ffffff;
}

.card-wrapper-dark {
   background-color: #283046;
   box-shadow: 0 4px 24px rgba(0, 0, 0, 0.25);
}

.skm-table :deep(th) {
   vertical-align: middle;
}

.skm-table :deep(td) {
   vertical-align: middle;
}
</style>
